import Vue from 'vue';
import { apolloClient } from '@/plugins/vue-apollo';
import {
  fetchCatalogsQuery,
  fetchCatalogItemsQuery,
  fetchCatalogItemQuery,
  fetchCatalogItemsStatistics,
  fetchCountDifferentBuyerQuery,
  fetchCountItemViewsQuery,
  fetchCountItemMatchQuery,
  fetchCountDifferentItemMatchQuery,
} from '@/store/graphql/queries/catalog';

export default {
  namespaced: true,
  state: {
    catalogs: {
      count: 0,
      data: [],
      defaultCatalog: null,
    },
    catalogItems: {
      count: 0,
      data: [],
    },
    catalogoStatitics: {
      published_items: 0,
      unpublished_items: 0,
      actived_users: 0,
    },
    matchStatitics: {
      buyers_views: 0,
      items_views: 0,
      items_match: 0,
      unique_items_match: 0,
    },
    currentProductItem: null,
  },
  actions: {
    async initialProductItem({ commit }) {
      commit('SET_CURRENT_PRODUCT_VIEW', {});
    },
    async searchCatalogs({ commit }) {
      try {
        const searchQuery = {
          query: fetchCatalogsQuery,
        };
        const { data } = await apolloClient.query(searchQuery);
        if (data) {
          commit('SET_SEARCH_CATALOG_RESULT', data);
        } else {
          throw new Error('searchCatalogs data is null');
        }
      } catch (error) {
        window.console.error(error);
      }
    },
    async searchCatalogItems({ commit, state }, filters) {
      try {
        const searchQuery = {
          fetchPolicy: 'network-only',
          query: fetchCatalogItemsQuery,
          variables: {
            offset: filters.offset,
            limit: filters.limit,
            keyword: filters.keyword,
            published_at_is_null: filters.published_at_is_null,
            price_gte: filters.price_gte,
            price_lte: filters.price_lte,
          },
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_SEARCH_CATALOG_ITEMS_RESULT', result.data);
        } else {
          throw new Error('searchCatalogItems data is null');
        }
      } catch (error) {
        window.console.error(error);
      }

      return state.catalogItems;
    },
    async get({ commit, state }, productId) {
      commit('SET_CURRENT_PRODUCT_VIEW', {});
      try {
        const searchQuery = {
          query: fetchCatalogItemQuery,
          variables: {
            productId,
          },
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_CURRENT_PRODUCT_VIEW', {
            productItem: result.data.item_by_pk,
          });
        } else {
          commit('SET_CURRENT_PRODUCT_VIEW', null);
        }
      } catch (error) {
        window.console.error(error);
      }

      return state.currentProductItem;
    },
    async getStatistics({ commit }) {
      try {
        const searchQuery = {
          query: fetchCatalogItemsStatistics,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_CATALOG_STATISTICS', result.data);
        }

        return result;
      } catch (error) {
        throw new Error(error);
      }
    },
    async getBuyerViews({ commit }) {
      try {
        const searchQuery = {
          query: fetchCountDifferentBuyerQuery,
          // variables: {
          //   from: filters.dateFrom,
          //   to: filters.dateTo,
          // },
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_CATALOG_BUYERS_VIEWS_STATISTICS', result.data);
        }

        return result;
      } catch (error) {
        throw new Error(error);
      }
    },
    async getItemsViews({ commit }) {
      try {
        const searchQuery = {
          query: fetchCountItemViewsQuery,
          // variables: {
          //   from: filters.dateFrom,
          //   to: filters.dateTo,
          // },
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_CATALOG_ITEMS_VIEWS_STATISTICS', result.data);
        }

        return result;
      } catch (error) {
        throw new Error(error);
      }
    },
    async getItemsMatch({ commit }) {
      try {
        const searchQuery = {
          query: fetchCountItemMatchQuery,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_TOTAL_ITEMS_MATCH', result.data);
        }

        return result;
      } catch (error) {
        throw new Error(error);
      }
    },
    async getUniqueItemsMatch({ commit }) {
      try {
        const searchQuery = {
          query: fetchCountDifferentItemMatchQuery,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_UNIQUE_ITEMS_MATCH', result.data);
        }

        return result;
      } catch (error) {
        throw new Error(error);
      }
    },
  },
  mutations: {
    SET_SEARCH_CATALOG_RESULT(state, data) {
      Vue.set(state.catalogs, 'data', data.catalog);
      Vue.set(state.catalogs, 'defaultCatalog', (data.defaultCatalog[0] || data.catalog[0]));
    },
    SET_SEARCH_CATALOG_ITEMS_RESULT(state, data) {
      Vue.set(state.catalogItems, 'data', [{ items: data.search_item }]);
      Vue.set(state.catalogItems, 'count', data.search_item_aggregate.aggregate.count);
    },
    SET_CURRENT_PRODUCT_VIEW(state, { productItem }) {
      Vue.set(state, 'currentProductItem', productItem);
    },
    SET_CATALOG_STATISTICS(state, data) {
      Vue.set(state.catalogoStatitics, 'published_items', data.published_items.aggregate.count);
      Vue.set(state.catalogoStatitics, 'unpublished_items', data.unpublished_items.aggregate.count);
      Vue.set(state.catalogoStatitics, 'actived_users', data.actived_users.aggregate.count);
    },
    SET_CATALOG_BUYERS_VIEWS_STATISTICS(state, data) {
      Vue.set(state.matchStatitics, 'buyers_views', data.item_visits_aggregate.aggregate.count);
    },
    SET_CATALOG_ITEMS_VIEWS_STATISTICS(state, data) {
      Vue.set(state.matchStatitics, 'items_views', data.item_visits_aggregate.aggregate.count);
    },
    SET_TOTAL_ITEMS_MATCH(state, data) {
      Vue.set(state.matchStatitics, 'items_match', data.item_match_aggregate.aggregate.count);
    },
    SET_UNIQUE_ITEMS_MATCH(state, data) {
      Vue.set(state.matchStatitics, 'unique_items_match', data.item_match_aggregate.aggregate.count);
    },
  },
  getters: {
    currentProductItemInfo: state => state.currentProductItem,
    catalogsInfo: state => state.catalogs.data,
    defaultCatalogInfo: state => state.catalogs.defaultCatalog,
    catalogoStatiticsInfo: state => state.catalogoStatitics,
    matchStatiticsInfo: state => state.matchStatitics,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/supplier/catalog.js